import { createSlice } from '@reduxjs/toolkit';
import type { LoteListDashboard, LoteListItem } from '../types/lotes.types';
import { listarLotesNegociacao } from './actions';

interface LotesState {
  items: LoteListItem[];
  dashboard: LoteListDashboard;
  pagination: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
  loading: boolean;
  error: string | null;
}

const initialState: LotesState = {
  items: [],
  dashboard: {
    totalLotes: 0,
    casosAtivos: 0,
    taxaAcordoMedia: 0,
    valorEmNegociacao: 0,
    totalBloqueados: 0,
    pendencias: 0,
  },
  pagination: { total: 0, page: 1, limit: 20, totalPages: 0 },
  loading: false,
  error: null,
};

const lotesSlice = createSlice({
  name: 'negociacoes/lotes',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(listarLotesNegociacao.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(listarLotesNegociacao.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.lotes;
        state.dashboard = action.payload.dashboard;
        state.pagination = action.payload.pagination;
      })
      .addCase(listarLotesNegociacao.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? 'Erro ao carregar lotes';
      });
  },
});

export default lotesSlice.reducer;
